import { Stack } from '@mui/material';
import { useCallback } from 'react';

import { IconButton } from '@/components/form/baseInputs/Button/IconButton';
import { CheckIcon } from '@/components/icons/CheckIcon';
import { ReverseLeftIcon } from '@/components/icons/ReverseLeftIcon';
import { Trash01Icon } from '@/components/icons/Trash01Icon';
import { Tooltip } from '@/components/poppers/Tooltip/Tooltip';

export interface NotificationItemActionsProps {
  isUnread: boolean;
  onDelete: () => void;
  onToggleRead: () => void;
}

export function NotificationItemActions({
  isUnread,
  onDelete,
  onToggleRead,
}: NotificationItemActionsProps) {
  const readLabel = isUnread ? 'Mark as read' : 'Mark as unread';

  const handleToggleRead = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      // stop propagation to avoid also firing the click handler on the
      // NotificationItem component
      e.stopPropagation();
      onToggleRead();
    },
    [onToggleRead]
  );

  const handleDelete = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      // stop propagation to avoid also firing the click handler on the
      // NotificationItem component
      e.stopPropagation();
      onDelete();
    },
    [onDelete]
  );

  return (
    <Stack direction="row" spacing={0.5}>
      <Tooltip title={readLabel}>
        <IconButton
          size="xs"
          variant="secondary"
          icon={isUnread ? CheckIcon : ReverseLeftIcon}
          ariaLabel={readLabel}
          onClick={handleToggleRead}
        />
      </Tooltip>
      <Tooltip title="Delete">
        <IconButton
          size="xs"
          variant="transparent"
          icon={Trash01Icon}
          ariaLabel="Delete"
          onClick={handleDelete}
        />
      </Tooltip>
    </Stack>
  );
}
